import get from 'lodash/get';
import * as types from './constants';

const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  projectDetails: {},
  projectFinancialSummary: {},
  eventLaunchDetails: {
    event_date: null,
    event_time: '',
  },
  exhibitionDetails: {
    ExhibitionId: '',
    EventLaunchDate: null,
    CountryId: '',
  },
  developerDetail: {},
  countriesList: [],
  exhibitions: [],
};

export default function PermitReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.UPDATE_PERMIT_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case types.UPDATE_PERMIT_STATE_BY_KEY_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case types.INITIATE_PERMITS_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESET_PERMITS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.PERMITS_LOADING_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case types.PERMITS_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.INITIATE_PERMITS_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: action.payload,
        applicationId: get(action.payload, 'applicationId', {}),
        conditions: get(action.payload, 'conditions', []),
        adminFeeScheduleDTOList: get(action.payload, 'adminFeeScheduleDTOList', []),
        projectDetails: get(action.payload, 'projectDetails', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        eventLaunchDetails: {
          event_date: get(action.payload?.exhibitionDetail, 'eventLaunchDate', null),
          event_time: get(action.payload?.exhibitionDetail, 'eventLaunchTime', ''),
        },
        exhibitionDetails: {
          ExhibitionId: get(action.payload?.exhibitionDetail, 'exhibitionId', null),
          EventLaunchDate: get(action.payload?.exhibitionDetail, 'eventLaunchDate', null),
          CountryId: get(action.payload?.exhibitionDetail, 'countryID', null),
        },
        agreementDetail: {
          accountTrusteeMuncipality: get(action.payload, 'projectDetails.trusteeMunicipalityId', ''),
          accountTrustee: get(action.payload, 'projectDetails.trusteeProfessionId', ''),
          developerRegistrationMunicipality: get(action.payload, 'projectDetails.developerRegisterMunicipalityId', ''),
          developerAddress: get(action.payload, 'projectDetails.developerAddress', ''),
          developerAddressAr: get(action.payload, 'projectDetails.developerAddressAr', ''),
          trusteeNameAr: get(action.payload, 'projectDetails.trusteeNameAr', ''),
          trusteeNameEn: get(action.payload, 'projectDetails.trusteeNameEn', ''),
          trusteeAddressEn: get(action.payload, 'projectDetails.trusteeAddressEn', ''),
          trusteeAddressAr: get(action.payload, 'projectDetails.trusteeAddressAr', ''),
        },
        accountDetail: {
          escrowAccountNumber: get(action.payload, 'projectDetails.escrowNumber', ''),
          escrowAccountIBAN: get(action.payload, 'projectDetails.escrowIban', ''),
          retentionAccountNumber: get(action.payload, 'projectDetails.retentionAccountNumber', ''),
          retentionIBANNumber: get(action.payload, 'projectDetails.retentionIBANNumber', ''),
        },
      };

    case types.PERMITS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.PERMITS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_APPLICATION_PERMITS_SUCCESS:
      const isInternationExhibition = action.payload?.applicationType === 'REQUEST_INTERNATIONAL_EXHIBITION_PERMIT';
      return {
        ...state,
        loading: false,
        error: null,
        application: action.payload,
        applicationId: get(action.payload, 'applicationId', null),
        developerDetail: get(action.payload, 'developerDetail', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        conditions: get(action.payload, 'conditions', []),
        adminFeeScheduleDTOList: get(action.payload, 'adminFeeScheduleDTOList', []),
        projectDetails: get(action.payload, 'projectDetails', {}),
        eventLaunchDetails: {
          event_date: get(action.payload?.exhibitionDetail, 'eventLaunchDate', null),
          event_time: get(action.payload?.exhibitionDetail, 'eventLaunchTime', ''),
        },
        exhibitionDetails: {
          ExhibitionId: get(action.payload?.exhibitionDetail, 'exhibitionId', ''),
          EventLaunchDate: get(
            action.payload?.exhibitionDetail,
            isInternationExhibition ? 'exhibitionLaunchDate' : 'eventLaunchDate',
            null,
          ),
          CountryId: get(action.payload?.exhibitionDetail, 'countryID', null),
        },
        agreementDetail: {
          accountTrusteeMuncipality: get(action.payload, 'projectDetails.trusteeMunicipalityId', ''),
          accountTrustee: get(action.payload, 'projectDetails.trusteeProfessionId', ''),
          developerRegistrationMunicipality: get(action.payload, 'projectDetails.developerRegisterMunicipalityId', ''),
          developerAddress: get(action.payload, 'projectDetails.developerAddress', ''),
          developerAddressAr: get(action.payload, 'projectDetails.developerAddressAr', ''),
          trusteeNameAr: get(action.payload, 'projectDetails.trusteeNameAr', ''),
          trusteeNameEn: get(action.payload, 'projectDetails.trusteeNameEn', ''),
          trusteeAddressEn: get(action.payload, 'projectDetails.trusteeAddressEn', ''),
          trusteeAddressAr: get(action.payload, 'projectDetails.trusteeAddressAr', ''),
        },
        accountDetail: {
          escrowAccountNumber: get(action.payload, 'projectDetails.escrowNumber', ''),
          escrowAccountIBAN: get(action.payload, 'projectDetails.escrowIban', ''),
          retentionAccountNumber: get(action.payload, 'projectDetails.retentionAccountNumber', ''),
          retentionIBANNumber: get(action.payload, 'projectDetails.retentionIBANNumber', ''),
        },
      };
    case types.INITIATE_PERMIT_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        brokers: get(action.payload, 'brokers', null),
        contractDetails: get(action.payload, 'contractDetails', {}),
        registrationFeeDetails: get(action.payload, 'registrationFeeDetails', {}),
      };

    case types.FETCH_PERMIT_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        mortgageDetails: get(action.payload, 'mortgageDetails', {}),
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
        bankSignatories: get(action.payload, 'bankSignatories', []),
        valuationCompanies: get(action.payload, 'valuationCompanies', []),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.SAVE_PERMIT_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', {}),
        property: get(action.payload, 'property', {}),
        activeStep: get(action.payload, 'step'),
        error: null,
      };
    case types.CHANGE_PERMIT_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.PERMIT_LOADING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
}
